import * as React from 'react';

import { Avatar, Tag } from 'antd';

import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

type TitleProps = {
  content: ChangeHistoryContentItem;
};

export const Title = ({ content }: TitleProps) => {
  const accountDescription = () => {
    if (content.isChangedBySupport) return 'Via Suporte Eduzz';
    if (content.isChangedByProducer) return 'Titular da conta';
    return 'Via controle de acesso';
  };

  const formatDate = (dateRaw: string) =>
    new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }).format(new Date(dateRaw));

  return (
    <>
      <div className='flex w-full cursor-pointer items-center justify-between'>
        <div className='flex'>
          <Avatar alt={content.customerNameWhoModified} src={content.customerPhoto} />
        </div>
        <div className='ml-3 grow'>
          <div>{formatDate(content.historyCreatedAt)}</div>
          <div>
            <Tag>{content.historyOrigin}</Tag>
            <span className='mx-3'>{content.customerNameWhoModified}</span>
            <span className='text-grey-400'>
              {accountDescription()} - {content.customerEmail}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
